(() => {
  const keys = ['wall', 'pendant', 'ceiling', 'table', 'clocks', 'lighting', 'all'];
  // Must match the Liquid paginate/loop page size. Every page is requested.
  const pageSize = 100;
  let countRequest;
  async function readPage(page) {
    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(root, window.location.origin);
    url.searchParams.set('section_id', 'zorura-category-count-data');
    url.searchParams.set('page', String(page));
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url.toString(), { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Category count request failed');
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const value = parsed.querySelector('[data-zorura-full-category-counts]')?.dataset.zoruraFullCategoryCounts;
    const fields = value?.split('|');
    if (!fields || fields.length !== keys.length || fields.some(n => !/^\d+$/.test(n))) throw new Error('Invalid category counts');
    const values = fields.map(Number);
    if (values.some(n => !Number.isSafeInteger(n))) throw new Error('Invalid category counts');
    const remaining = Math.max(0, Math.min(pageSize, values[6] - (page - 1) * pageSize));
    if (values.slice(0, 6).some(n => n > remaining)) throw new Error('Invalid category page');
    return values;
  }
  function loadCounts() {
    if (!countRequest) {
      countRequest = (async () => {
        const first = await readPage(1);
        const total = first[6];
        // Shopify cannot paginate a Liquid array beyond item 25,000.
        // Report an error and preserve cards instead of using partial counts.
        if (total > 25000) throw new Error('Catalog exceeds Shopify Liquid pagination capacity');
        const counts = first.slice();
        for (let page = 2; page <= Math.ceil(total / pageSize); page += 1) {
          const next = await readPage(page);
          if (next[6] !== total) throw new Error('Catalog changed while counting');
          for (let index = 0; index < 6; index += 1) counts[index] += next[index];
        }
        return Object.fromEntries(keys.map((key, index) => [key, counts[index]]));
      })();
    }
    return countRequest;
  }
  function updateCategories() {
    loadCounts().then(counts => {
      const value = keys.map(key => counts[key]).join('|');
      document.querySelectorAll('[data-zorura-full-category-counts]').forEach(element => {
        element.dataset.zoruraFullCategoryCounts = value;
        element.dataset.zoruraCountsState = 'ready';
      });
      document.querySelectorAll('[data-zorura-category]').forEach(element => {
        const count = counts[element.dataset.zoruraCategory];
        if (typeof count === 'number') element.hidden = count < 5;
      });
    }).catch(error => {
      countRequest = undefined;
      document.querySelectorAll('[data-zorura-full-category-counts]').forEach(element => {
        element.dataset.zoruraCountsState = 'error';
      });
      console.warn('Zorura category counts could not be refreshed:', error.message);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateCategories, { once: true });
  else updateCategories();
  document.addEventListener('shopify:section:load', updateCategories);
  new MutationObserver(records => {
    const relevant = records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches('[data-zorura-category], [data-zorura-full-category-counts]') ||
        node.querySelector('[data-zorura-category], [data-zorura-full-category-counts]'))
    ));
    if (relevant) updateCategories();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
